export default __webpack_public_path__ + "static/bg_mobile-6c53a255a832d2ecf63f3af42559e4ba.jpg";